module.exports = __webpack_public_path__ + "img/9.36a35dac.svg";